
import Search from 'vux/src/components/search/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from './api'
export default {
components: {
Search,
Tab,
TabItem,
Group,
Panel,
Toast
},
mounted() {
},
methods: {
onItemClick () {
console.log('click tab', this.tabIndex);
this.onSubmit(undefined);
},
onImgError(){

},
setFocus () {
this.$refs.search.setFocus()
},
resultClick (item) {
window.alert('you click the result item: ' + JSON.stringify(item))
},
getResult (val) {
console.log('on-change', val)
this.results = val ? getResult(this.value) : []
},
onSubmit (val) {

let ptype="CP";
if(this.tabIndex==0){
ptype="CP";
}
else if(this.tabIndex==1){
ptype="MP";
}
if(val!==undefined){
this.searchValue=val;
}
post('/productinfo/search', {PType:ptype,keyFilter:this.searchValue}).then(response => {
console.log(response);
this.productInfo.splice(0, this.productInfo.length);
if(response.code==1){
let index=0;
response.data.forEach(element => {
let picUrl=this.GLOBAL.mpUrl;
if(element.PType=='MP'){
picUrl=this.GLOBAL.mpUrl;
}
else if(element.PType=='CP'){
picUrl=this.GLOBAL.cpUrl;
}

this.productInfo.push({
src: picUrl,
title: element.title,
desc: element.desc,
url: '/ProductDetail?id='+index+'&tag=S'
});
index++;
});
this.productDatas=response.data;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
this.productInfo.splice(0, this.productInfo.length);
console.log(error);
});
},
onFocus () {
console.log('on focus')
},
onCancel () {
console.log('on cancel')
},
onClickItem(item){
this.GLOBAL.currentObjs=this.productDatas;
}
},
data () {
return {
type: '5',
productDatas:[],
productInfo: [],
footer: {
title: "",
url: ''
},
results: [],
searchValue: '',
tabIndex:0,
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'产品发布成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
}
}
}
function getResult (val) {
let rs = []
for (let i = 0; i < 20; i++) {
rs.push({
title: `${val} result: ${i + 1} `,
other: i
})
}
return rs
}



// WEBPACK FOOTER //
// ./src/components/SearchPage.vue